<!-- kui-select won't allow any html (including extra spaces) so went back to plain old <select> -->
<!-- <kui-select [options]="comboValues"
(change)="comboChanged($event)"></kui-select> -->

<select
    kui-input
    [disabled]="field.readonly"
    [required]="field.required"
    (change)="comboChanged($event.target.value)"
    [class.border-danger]="error || (field.required && touched && !value)"
>
    @if (!field.required || !value) {
        <option value="" [disabled]="field.required" selected></option>
    }
    @for (option of comboValues; track option) {
        <option [value]="option.key" [selected]="option.key === value">{{ "&nbsp;".repeat(option.indent * 3) }}{{ option.value }}</option>
    }
</select>

@if (field.required && touched && !value) {
    <div class="invalid-feedback d-block">
        <div>{{ "FORMS.SHARED.REQUIRED" | translate: { field: field.title } }}</div>
    </div>
}
@if (error) {
    <div class="invalid-feedback d-block">
        <div>{{ error }}</div>
    </div>
}
